import { Link } from "react-router-dom";
import { Card, CardContent } from "../ui/card";
import { formatDate } from "../../lib/utils";
import { MiniKpi } from "./atoms";

export default function CrmSummaryCard({ crmStats, clientStats, activity }) {
  if (!crmStats) return null;
  return (
    <Card className="border-slate-200 shadow-sm" data-testid="crm-summary">
      <CardContent className="p-6">
        <div className="flex flex-wrap items-center justify-between mb-4">
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">Sales &amp; delivery</p>
            <h2 className="text-xl font-semibold tracking-tight text-[#0D1B2A]">Pipeline snapshot</h2>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/crm" className="text-[#1A7F6E] text-sm hover:underline font-medium">Leads →</Link>
            <Link to="/clients" className="text-[#1A7F6E] text-sm hover:underline font-medium">Clients →</Link>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mb-6">
          <MiniKpi label="Active leads" value={crmStats.total} testid="kpi-active-leads" />
          <MiniKpi label="Active clients" value={clientStats?.total || 0} tint="text-[#1A7F6E]" testid="kpi-active-clients" />
          <MiniKpi label="Converted (mo)" value={clientStats?.converted_this_month || 0} testid="kpi-converted" />
          <MiniKpi label="Certified (mo)" value={clientStats?.won_this_month || 0} tint="text-[#1A7F6E]" />
          <MiniKpi label="Lost (mo)" value={crmStats.lost_this_month} tint="text-[#DC2626]" />
        </div>
        <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Lead stages</p>
        <div className="grid grid-cols-6 gap-1 mb-4">
          {Object.entries(crmStats.by_stage || {}).map(([k, v]) => (
            <div key={k} className="text-center bg-slate-50 rounded p-2">
              <p className="text-[10px] text-slate-500 truncate">{k.replace(/_/g, " ")}</p>
              <p className="text-lg font-semibold text-[#0D1B2A]">{v}</p>
            </div>
          ))}
        </div>
        {clientStats?.by_stage && (
          <>
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Client stages</p>
            <div className="grid grid-cols-6 gap-1">
              {Object.entries(clientStats.by_stage).map(([k, v]) => (
                <div key={k} className="text-center bg-[#E6F4F1]/60 rounded p-2">
                  <p className="text-[10px] text-slate-500 truncate">{k.replace(/_/g, " ")}</p>
                  <p className="text-lg font-semibold text-[#1A7F6E]">{v}</p>
                </div>
              ))}
            </div>
          </>
        )}
        {activity.length > 0 && (
          <div className="mt-6">
            <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Recent activity</p>
            <ul className="text-sm space-y-1.5">
              {activity.slice(0, 5).map((a) => (
                <li key={a.id} className="flex justify-between gap-3 border-b border-slate-100 pb-1.5">
                  <span className="text-slate-700 truncate">
                    <span className="font-medium text-[#0D1B2A]">{a.actor_name || a.actor_email}</span> · {a.text}
                  </span>
                  <span className="text-xs text-slate-400 whitespace-nowrap">{formatDate(a.at)}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
